import { ShiftResponseDto } from "../shared/dtos/shift/ShiftResponseDto";
import { ShiftSummaryDto } from "../shared/dtos/shift/ShiftSummaryDto";

export class ShiftMapper {
  public static mapShiftResponseToSummary(
    shiftResponse: ShiftResponseDto,
  ): ShiftSummaryDto {
    return {
      id: shiftResponse.id,
      branchName: shiftResponse.branchName,
      cashier: shiftResponse.cashier,
      startTime: shiftResponse.startTime,
      endTime: shiftResponse.endTime,
      isOpen: shiftResponse.isOpen,
      openingFloat: shiftResponse.openingFloat,
      expectedCash: shiftResponse.expectedCash,
      cashDiscrepancy: shiftResponse.cashDiscrepancy,
    };
  }
}
